module.exports = __webpack_public_path__ + "822b11e97eb3d4e5bd5994ca39068da7.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/theater-2015.jpg
// module id = 536
// module chunks = 0